import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  commonSlide: false,
  blogTypeSlide: false,
  bannerSlide: false,
  partnerSlide: false,
  usersSlide: false,
  selectedBlogType: null,
  selectedBanner: null,
  selectedPartner: null,
  selectedUser: null,
  
  skillTypeSlide: false,
  skillsSlide: false,
  industriesSlide: false,
  commonDeleteModal: false,

  blogsSlide: false,
  
  selectedBlogs: null,
  selectedSkillType: null,
  selectedSkills: null,
  selectedIndustries: null,
  selectedTeamMember: null,
  selectedMember: null,
  selectedFonts:null,
  selectedStat:null,
  selectedEnquiry:null,
  selectedTransaction:null,
  selectedCv:null,
  selectedCoverLetter:null,
  selectedJobs:null
  

};

const commonStateSlice = createSlice({
  name: 'commonState',
  initialState,
  reducers: {
    toggleCommonSlide: state => {
      state.commonSlide = !state.commonSlide;
    },
    toggleBlogTypeSlide: state => {
      state.blogTypeSlide = !state.blogTypeSlide;
    },
    toggleBannerSlide: state => {
      state.bannerSlide = !state.bannerSlide;
    },
    toggleJobsSlide: state => {
      state.jobsSlide = !state.jobsSlide;
    },
    togglePartnerSlide: state => {
      state.partnerSlide = !state.partnerSlide;
    },
    toggleTeamMemberSlide: state => {
      state.userTeamMemberSlide = !state.userTeamMemberSlide;
    },
    toggleUserSlide: state => {
      state.usersSlide = !state.usersSlide;
    },
    setSelectedBlogType: (state, action) => {
      state.selectedBlogType = action.payload;
    },
    setSelectedBanner: (state, action) => {
      state.selectedBanner = action.payload;
    },
    setSelectedPartner: (state, action) => {
      state.selectedPartner = action.payload;
    },
    setSelectedTeamMember: (state, action) => {
      state.selectedTeamMember = action.payload;
    },
    setSelectedMember: (state, action) => {
      state.selectedMember = action.payload;
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    toggleBlogsSlide: state => {
      state.blogsSlide = !state.blogsSlide;
    },
    toggleSkillTypeSlide: state => {
      state.skillTypeSlide = !state.skillTypeSlide;
    },
    toggleSkillsSlide: state => {
      state.skillsSlide = !state.skillsSlide;
    },
    toggleIndustriesSlide: state => {
      state.industriesSlide = !state.industriesSlide;
    },
    toggleFontsSlide: state => {
      state.fontsSlide = !state.fontsSlide;
    },

    toggleCommonDeleteModal: state => {
      state.commonDeleteModal = !state.commonDeleteModal;
    },

    setSelectedBlogs: (state, action) => {
      state.selectedBlogs = action.payload;
    },
    setSelectedSkillType: (state, action) => {
      state.selectedSkillType = action.payload;
    },
    setSelectedSkills: (state, action) => {
      state.selectedSkills = action.payload;
    },
    setSelectedIndustries: (state, action) => {
      state.selectedIndustries = action.payload;
    },
    setSelectedFonts: (state, action) => {
      state.selectedFonts = action.payload;
    },
    setSelectedStat: (state, action) => {
      state.selectedStat = action.payload;
    },
    setSelectedEnquiry: (state, action) => {
      state.selectedEnquiry = action.payload;
    },
    setSelectedTransaction: (state, action) => {
      state.selectedTransaction = action.payload;
    },
    setSelectedCv: (state, action) => {
      state.selectedCv = action.payload;
    },
    setSelectedJobs: (state, action) => {
      state.selectedJobs = action.payload;
    },
  },

});

export const commonStateReducer = commonStateSlice.reducer;

export const {
   toggleCommonSlide, 
   toggleBlogTypeSlide,
   toggleBannerSlide,
   toggleJobsSlide,
   togglePartnerSlide,
   toggleTeamMemberSlide,
   toggleBlogsSlide,
   toggleSkillTypeSlide,
   toggleSkillsSlide,
   toggleIndustriesSlide,
   toggleFontsSlide,
   toggleCommonDeleteModal,
   toggleUserSlide,
   setSelectedBlogs,
   setSelectedSkills,
   setSelectedSkillType,
   setSelectedIndustries,
   setSelectedBlogType,
   setSelectedBanner,
   setSelectedPartner,
   setSelectedTeamMember,
   setSelectedMember,
   setSelectedFonts,
   setSelectedStat,
   setSelectedEnquiry,
   setSelectedTransaction,
   setSelectedCv,
   setSelectedCoverLetter,
   setSelectedJobs,
   setSelectedUser
   
  } = commonStateSlice.actions;

export const selectCommonSlide = (state) => state.commonState.commonSlide;
export const selectBlogTypeSlide = (state) => state.commonState.blogTypeSlide;
export const selectBannerSlide = (state) => state.commonState.bannerSlide;
export const selectPartnerSlide = (state) => state.commonState.partnerSlide;
export const selectJobsSlide = (state) => state.commonState.jobsSlide;
export const selectFontsSlide = (state) => state.commonState.fontsSlide;
export const selectUsersSlide = (state) => state.commonState.usersSlide;

export const selectTeamMemberSlide = (state) => state.commonState.userTeamMemberSlide;
export const selectSelectedBlogType = (state) => state.commonState.selectedBlogType;
export const selectSelectedBanner = (state) => state.commonState.selectedBanner;
export const selectSelectedPartner = (state) => state.commonState.selectedPartner;
export const selectSelectedTeamMemberMember = (state) => state.commonState.selectedTeamMember;
export const selectSelectedMemberMember = (state) => state.commonState.selectedMember;
export const selectSelectedUser = (state) => state.commonState.selectedUser;


export const selectBlogsSlide = (state) => state.commonState.blogsSlide;
export const selectSkillTypeSlide = (state) => state.commonState.skillTypeSlide;
export const selectSkillsSlide = (state) => state.commonState.skillsSlide;
export const selectIndustriesSlide = (state) => state.commonState.industriesSlide;
export const selectCommonDeleteModal = (state) => state.commonState.commonDeleteModal;

export const selectSelectedBlogs = (state) => state.commonState.selectedBlogs;
export const selectSelectedSkillType = (state) => state.commonState.selectedSkillType;
export const selectSelectedSkills = (state) => state.commonState.selectedSkills;
export const selectSelectedIndustries = (state) => state.commonState.selectedIndustries;
export const selectSelectedFonts = (state) => state.commonState.selectedFonts;
export const selectSelectedStat = (state) => state.commonState.selectedStat;
export const selectSelectedEnquiry = (state) => state.commonState.selectedEnquiry;
export const selectSelectedTransaction = (state) => state.commonState.selectedTransaction;
export const selectSelectedCv = (state) => state.commonState.selectedCv;
export const selectSelectedCoverLetter = (state) => state.commonState.selectedCoverLetter;
export const selectSelectedJobs = (state) => state.commonState.selectedJobs;
